import { apiClient } from './client';
import type { QuizQuestion } from '../types';

export interface QuizConfig {
  mode: 'mc' | 'written';
  word_count?: number;
  tag?: string;
  difficulty?: number;
  sheet?: string;
  strategy?: 'due' | 'random' | 'weak' | 'new';
  timed?: boolean;
  time_seconds?: number;
}

export interface QuizResult {
  word_id: string;
  correct: boolean;
  response_time_ms: number;
  answer?: string;
}

export async function generateQuiz(config: QuizConfig): Promise<QuizQuestion[]> {
  const { data } = await apiClient.post<QuizQuestion[]>('/quiz/generate', config);
  return data;
}

export interface GradeResponse {
  correct: boolean;
  confidence: number;
  feedback: string;
}

export async function gradeWritten(wordId: string, answer: string): Promise<GradeResponse> {
  const { data } = await apiClient.post<GradeResponse>('/quiz/grade', {
    word_id: wordId,
    answer,
  });
  return data;
}

export async function submitQuizResults(
  results: QuizResult[],
  mode: 'mc' | 'written' = 'mc'
): Promise<{ xp_earned: number }> {
  const { data } = await apiClient.post<{ xp_earned: number }>('/progress/quiz', { results, mode });
  return data;
}
